import BaseClass from "../BaseClass.js";

export default class AutoReloadContainer extends BaseClass {

    constructor(element) {
        super(element);

        this.contentUrl = this.$element.attr('data-url');
        this.timeout = this.$element.attr('data-timeout');
        this.contentHolder = this.$element.children('.autoreload').first();
        this.halt = false;
        this.loading = false;
        this.jqxhr = null;
        this.loadContent();
    }

    replaceContent(data) {

        this.contentHolder.html(data);

        $(document).trigger("content:loaded");

        this.halt = this.hasHaltMarker(this.$element);

        if (!this.halt) {
            let mySelf = this;
            this.timer = setTimeout(function () {
                mySelf.loadContent();
            }, this.timeout * 1000);
            return;
        }

        this.$element.attr('data-state', 'init_halt');
    }

    loadContent() {
        if (this.loading) {
            return false;
        }

        this.loading = true;
        const mySelf = this;

        this.jqxhr = $.post(this.contentUrl, function () {
            // nix
        }, 'html')
            .done(function (data) {
                mySelf.replaceContent(data);
                mySelf.loading = false;
                mySelf.jqxhr = null;
            })
            .fail(function (data) {
                mySelf.loading = false;
                mySelf.jqxhr = null;
                mySelf.halt = true;
            })
            .always(function () {
                // nix
            });
    }


    hasHaltMarker($element) {
        return $element.find('[data-halt]').length !== 0;
    }
}